export default __webpack_public_path__ + "static/logo-white-6521ea2df0e327b2bf9a4cfd36676181.svg";